import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkAngled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7.379 10.19-2.234 2.234a4.45 4.45 0 0 0 .047 6.343 4.45 4.45 0 0 0 3.181 1.352c1.22.009 2.328-.444 3.162-1.278l2.234-2.233m2.853-2.799 2.233-2.233a4.451 4.451 0 0 0-.047-6.343 4.54 4.54 0 0 0-3.18-1.325 4.4 4.4 0 0 0-3.163 1.278l-2.233 2.233m-1.619 7.908 6.7-6.7"
    />
  </svg>
);
export default SvgLinkAngled;
